/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

// import { accountType } from '@/components/_modules/Admin/settings'

const tabs = () => (
  [SCANNING_QUEUE, HISTORY]
)

export default {
  get tabs() { return tabs() }
}

//
const SCANNING_QUEUE = {
  label: 'Scanning Queue',
  href: { params: { page: 'InvoiceScan', section: 'queue' } }
}

const HISTORY = {
  label: 'History',
  href: { params: { page: 'InvoiceScan', section: 'history' } }
}



// WEBPACK FOOTER //
// ./src/components/_modules/InvoiceScan/tabs.js